/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import HelpModal from 'cio/components/help-modal';
import AnalyticsService from 'cio/services/analytics';

const SOURCE_MAP: Record<string, string> = {
  'integrations.facebook_lead_ads.index': 'Form Settings Tab',
  'campaigns.campaign.setup.goal.index': 'Campaign Goal & Exit',
};

export default class FormsFacebookLeadAdsConversionFeedbackForm extends HelpModal {
  @service analytics!: AnalyticsService;
  @service router!: RouterService;

  @tracked conversionTrackingFeedback = '';

  @action
  trackOpen() {
    this.analytics.track('facebook_lead_ads', 'conversion_enabled', { from: SOURCE_MAP[this.router.currentRouteName] });
  }

  @action
  submitConversionFeedback(evt: Event) {
    evt.preventDefault();

    this.submitFeedback.perform({
      praise: this.conversionTrackingFeedback,
      criticism: 'Requesting support for sending Facebook Lead Ads to Facebook.',
    });
  }
}
